import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GgwDevZoneAssignmentComponent } from './components/ggw-dev-zone-assignment/ggw-dev-zone-assignment.component';
import {ButtonModule, CheckboxModule, DataTableModule} from "primeng/primeng";
import {UIBaseModule} from "@catui/ui-base.module";
import {GgwDevZoneAssignmentService} from "@catmodels/ggw-dev-zone-assignment/services/ggw-dev-zone-assignment.service";
import { ModifyGgwDevZoneAssignmentComponent } from './components/modify-ggw-dev-zone-assignment/modify-ggw-dev-zone-assignment.component';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {UIFormModule} from "@catuiform/ui-form.module";
import {GgwDeviceModule} from "@catmodels/ggw-device/ggw-device.module";

const publicComponents = [
  GgwDevZoneAssignmentComponent,
  ModifyGgwDevZoneAssignmentComponent,
];

const imports = [
    CommonModule,
    DataTableModule,
    UIBaseModule,
    ButtonModule,
    FormsModule,
    UIFormModule,
    ReactiveFormsModule,
    GgwDeviceModule,
    CheckboxModule,
];

const declarations = [
  ...publicComponents,
];

const exportings = [...publicComponents];

const providers = [GgwDevZoneAssignmentService];
const entryComponents = [...publicComponents];


@NgModule({
  declarations,
  entryComponents,
  exports: exportings,
  imports,
  providers,
})
export class GgwDevZoneAssignmentModule { }



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/ggw-dev-zone-assignment/ggw-dev-zone-assignment.module.ts